import { Avatar, Box, Stack, Tooltip, Typography } from "@mui/joy";
import { getFileExtension, getFileExtensionIcon, isImage } from "@utils/files";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import DownloadDoneRoundedIcon from '@mui/icons-material/DownloadDoneRounded';
import toast from "react-hot-toast";

export function AddFileThumbnail({ onClick, layout = 'list' }) {

    const name = 'Press here or drag a file to upload it';

    return (
        <Tooltip title={layout === 'grid' ? name : false}>
            <Stack
                direction={layout === 'list' ? 'row' : 'column'}
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                sx={{
                    aspectRatio: layout === 'list' ? 'unset' : 1,
                    position: 'relative',
                    cursor: 'pointer',
                    '&:hover': {
                        '.normal-icon': {
                            // opacity: 0,
                        },
                        '.hover-icon': {
                            opacity: 1,
                        },
                        //
                    },
                }}
                onClick={onClick}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Avatar
                        size="lg"
                        variant="solid"
                        sx={theme => ({
                            '--Avatar-radius': 'var(--joy-radius-sm)',
                            '.drag-over &': {
                                bgcolor: theme.palette.success[500],
                            },
                            ...((layout === 'grid') && {
                                '--Icon-fontSize': '3.5vw',
                                width: '100%',
                                height: 'unset',
                                aspectRatio: 1,
                                position: 'absolute',
                                top: 0,
                                'svg': {
                                    // 8px comes from the py: 0.5
                                    transform: 'translateY(calc((var(--joy-fontSize-sm) + 8px) * -0.5))',
                                }
                            })
                        })}
                    >
                        <Box className="normal-icon" sx={{position: 'absolute'}}>
                            <FileUploadRoundedIcon/>
                        </Box>
                    </Avatar>
                    <Avatar
                        className="hover-icon"
                        size="lg"
                        variant="solid"
                        sx={theme => ({
                            '--Avatar-radius': 'var(--joy-radius-sm)',
                            position: 'absolute',
                            opacity: 0,
                            transition: '0.2s ease',
                            '.drag-over &': {
                                bgcolor: theme.palette.success[500],
                            },
                            ...((layout === 'grid') && {
                                '--Icon-fontSize': '3.5vw',
                                width: '100%',
                                height: 'unset',
                                aspectRatio: 1,
                                top: 0,
                                'svg': {
                                    // 8px comes from the py: 0.5
                                    transform: 'translateY(calc((var(--joy-fontSize-sm) + 8px) * -0.5))',
                                }
                            })
                        })}
                    >
                        <DownloadDoneRoundedIcon/>
                        {/* <Box sx={{position: 'relative'}}> */}
                            {/* <Box className="normal-icon" sx={{position: 'absolute'}}>{fileIcon}</Box> */}
                        {/* </Box> */}
                    </Avatar>
                </Box>
                <Typography
                    fontSize={'sm'}
                    sx={theme => ({
                        ...((layout === 'grid') && {
                            position: 'absolute',
                            bottom: 0,
                            mt: 0,
                            px: 1.5,
                            py: 0.5,
                            width: '100%',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            textOverflow: 'ellipsis',
                            backgroundColor: 'rgba(0,0,0,0.6)',// theme.palette.background.backdrop,
                            color: theme.palette.common.white,
                            borderBottomLeftRadius: 'var(--joy-radius-sm)',
                            borderBottomRightRadius: 'var(--joy-radius-sm)',
                        })
                    })}
                >
                    {layout === 'grid' ? 'Upload File' :  name}
                </Typography>
            </Stack>
        </Tooltip>
    );
}
